"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Router = _interopRequireDefault(require("./router/Router"));

var _redux = require("../redux");

var _utils = require("../utils"); // import app components


var JamCMS = function JamCMS(props) {
  var fields = props.fields,
      source = props.source,
      settings = props.settings,
      privateTemplateExists = props.privateTemplateExists;
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: _redux.store
  }, /*#__PURE__*/_react.default.createElement(_Router.default, {
    pageContext: props === null || props === void 0 ? void 0 : props.pageContext,
    defaultComponent: props.children,
    config: {
      source: source,
      settings: settings,
      privateTemplateExists: privateTemplateExists
    },
    fields: (0, _utils.formatFields)(fields)
  }));
};

var _default = JamCMS;
exports.default = _default;